/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { UnitDependencies } from './dependenciesUnitClass.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createUnitFunction } from '../../factoriesAny.js';
export var unitDependencies = {
  UnitDependencies,
  typedDependencies,
  createUnitFunction
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesUnitFunction.generated.js
// module id = IpSk
// module chunks = 3